const $ = require('rgs-jquery');
const window = require('window');
const yaCounter = require('yandex-counter');

$(function () {
	$(window.document).on(
		'click.yandex-counter.data-api',
		'[data-yc-reach]',
		function (e) {
			const $target = $(e.target);

			const reach = $target.attr('data-yc-reach');
			yaCounter.reachGoal(reach);
		}
	);
});
